import {createStyles, Theme} from "@material-ui/core";
import {boxShadow, buttonOutlined, styleColors} from "src/main.style";

export const ChangesStyle = (theme: Theme) => createStyles({
  buttonOutlined,
  changeScheduleHeader : {
    display:'flex',
    width: '100%',
    textAlign: 'center',
    placeContent: 'center',
    alignItems: 'center', 
    fontWeight: 700,
    padding: '18px 0px 8px',
    flex:1,
  },
  changeInfoView : {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    padding: '24px',
  },
  changeInfoBox : {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: styleColors.greyLight1,
    padding: '24px',
    marginBottom: '40px',
    borderRadius: '8px',
    border: `1px solid ${styleColors.greyMedium1}`,
    boxShadow: [
      `0px 2px 4px -1px ${styleColors.blackAlpha18}`,
      `0px 4px 5px 0px ${styleColors.blackAlpha12}`,
      `0px 1px 10px 0px ${styleColors.blackAlpha12}`,
    ].join(","),
    minWidth: 'calc(100% - 20px)',
    maxWidth: 'calc(100% - 20px)',
    boxSizing: 'border-box',
    margin: '10px',
  },
  changeInfoHeader : {
    fontSize: '18px',
    marginBottom: '12px',
    fontWeight: 500,
    letterSpacing: '0.5px',
  },
  changeInfoCaption : {
    fontSize: '12px',
    marginBottom: '12px',
    fontWeight: 400,
  },
  changeInfoRow : {
    display: 'flex',
    flexDirection: 'row',
  },
  changeInfoColumn : {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  changeInfoLabel : {
    color:styleColors.greyMedium3,
    marginBottom: '10px',
    fontStyle: 'italic',
  },
  changeInfoValue : {
    fontWeight:600,
  },
  paneStatus  :{
    fontSize: '12px',
  },
  paneChangeStep : {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'space-between',

  },
  paneChangeArrowButton : {
    backgroundColor:`${styleColors.greyLight2} !important`,
    padding: '12px',
  },
  changesContainer : {
    display:'flex',
    // minWidth: '100%',
    // maxWidth: '100%',
    maxWidth: 'calc(100% + 20px)',
    minWidth: 'calc(100% + 20px)',
    marginLeft: '-10px',
    overflow: 'auto',
    scrollSnapType: 'x',
    scrollPadding: '0px',
  },
  changeContainer : {
    minWidth: '100%',
    maxWidth: '100%',
    margin: '20px 0px',
    scrollSnapAlign: 'start'
  },
  widePaper : {
    flexGrow: 1,
    padding: '12px',
  },
});



// WEBPACK FOOTER //
// ./src/components/calendar2/suggestion/changes.style.ts